module.exports = __webpack_public_path__ + "img/pr-6.6821a2e6.png";